export class Quote {
  public quoteId: number;
  public plantId: number;
  public plantNumber: number;
  public plantName: string;
  public productLineId: number;
  public modelId: number;
  public modelDesc: string;
  public customerId: number;
  public customer: string;
  public userId: number;
  public DateCreated: Date;
  public LastModifiedDate: Date;
  public DateApproved: Date;
  public expirationDate?: Date;
  public retailerNumber: string;
  public retailerName: string;
  public inactiveStatus: boolean;
  public createdBy: string;
  public modifiedBy: string;
  public IsLocked: boolean;
  public LockedBy: number;
  public QuoteStatusesID: number;
  public ApprovalStatusDescription: string;
  public status: string;
  public mdm: string;
  public approvalStatus?: number;
  public approvalNote: string;
  public iseriesQuoteNumber: number;
  public prospectId: number;
  public revisionNumber: number;
  public revisionComments: string;

  // Subtotal and Grand Total Info
  public NoPricing: boolean;
  public BaseCost: number;
  public OptionsTotal: number;
  public VipDiscountAmount: number;
  public PartnerAssistanceAmount: number;
  public Surcharge: number;
  public Transportation: number;
  public Taxes: number;
  public Dues: number;
  public DiscountPercent: number;
  public GrandTotal: number;
  public ModelBaseOverride: number;
  public ModelBaseCost: number;

  // paging used with Quote Approvals(Management) page
  public CurrentPage: number;
  public TotalPageCount: number;

  constructor() {
    this.prospectId = null;
    this.quoteId = null;
    this.plantId = null;
    this.productLineId = null;
    this.modelId = null;
    this.customerId = null;
    this.BaseCost = null;
      this.OptionsTotal = null;
      this.VipDiscountAmount = null;
    this.PartnerAssistanceAmount = null;
    this.Surcharge = null;
    this.Transportation = null;
    this.Taxes = null;
    this.Dues = null;
    this.DiscountPercent = null;
    this.GrandTotal = null;
    this.revisionNumber = null;
    this.revisionComments = null;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/quote.ts